export class GetCellBySnFrom1CQuery {
    httpQueryId: string;
    serialNumbers: string[] = [];
}